/**
 * @file 列表页-批量操作区
 * @author alfielv
 */
import React, { useCallback } from 'react';
import Toolbar from '../Toolbar';
export default (function (props) {
  var prefixCls = props.prefixCls,
      batchConfig = props.batchConfig,
      _props$selectKeys = props.selectKeys,
      selectKeys = _props$selectKeys === void 0 ? [] : _props$selectKeys,
      setSelectKeys = props.setSelectKeys,
      setBatchShow = props.setBatchShow;
  var leftToolbarConfig = batchConfig.left,
      rightToolbarConfig = batchConfig.right,
      _batchConfig$unit = batchConfig.unit,
      unit = _batchConfig$unit === void 0 ? '项' : _batchConfig$unit; // 关闭多选操作区

  var handleClose = useCallback(function () {
    setSelectKeys([]);
    setBatchShow(false);
  }, [setSelectKeys, setBatchShow]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__batch-area")
  }, /*#__PURE__*/React.createElement(Toolbar, {
    type: "mass",
    leftFixer: /*#__PURE__*/React.createElement(React.Fragment, null, "\u5DF2\u9009\u62E9", /*#__PURE__*/React.createElement("span", {
      className: "select-keys-count"
    }, selectKeys.length), unit),
    left: leftToolbarConfig,
    right: rightToolbarConfig,
    clear: true,
    onClose: handleClose
  }));
});